import { render, staticRenderFns } from "./WorkflowFullTextTab.vue?vue&type=template&id=b96d7966&"
import script from "./WorkflowFullTextTab.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFullTextTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports